import React, { PureComponent } from 'react';

import styled from 'styled-components';

import Text from '@components/atoms/Text/Text';

import { breakpoint } from 'theme';

type ErrorFormFieldProps = {
  className?: string;
  error?: string;
};

class ErrorFormField extends PureComponent<ErrorFormFieldProps> {
  render() {
    return (
      <div role="alert" className={this.props.className}>
        <Text smSize={0.75} size={0.875} color="white" weight={600}>
          {this.props.error}
        </Text>
      </div>
    );
  }
}

const styledErrorFormField = styled(ErrorFormField)`
  position: absolute;
  top: -0.25em;
  right: 0;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.flushOrange};
  padding: 0.25em 0.5em;
  display: flex;
  transition: opacity 0.25s, visibility 0s;

  &::after {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5.5px 0 5.5px;
    border-color: ${props => props.theme.colors.flushOrange} transparent
      transparent transparent;
    content: '';
    position: absolute;
    right: 15px;
    bottom: -5px;

    ${breakpoint.m`
      right: 22px;
    `}
  }
`;

export default styledErrorFormField;
